export const getInstrumentsByFilter = `
  query SearchInstrumentsByISIN(
    $filter: InstrumentFilterInput
  )
  {
    searchInstruments(
      filter: $filter
    ){
      items {
        instrument {
          ... on ShareInstrument {
            id
            name
            isin
            assetClass
            active
            covered
            delisted
            latestPrice {
                price
            }
          }
          ... on EtfInstrument {
            id
            name
            isin
            assetClass
            active
            covered
            delisted
            latestPrice {
                price
            }
          }
        }
      }
    }
  }
`
